import { Inbox, Radio, ListChecks, Users, MoreHorizontal } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useShellStore, SHELL_BOTTOM_BAR } from '@/stores/shell-store.js';

// Queue leads on mobile (MV-10: see-and-respond on iPhone is the queue's
// job). Pipeline moved to the More page; its route stays live.
// The bar yields while a page owns the bottom (shell-store bottomBar): the
// v3 account page's PhoneBar claims it on mount, so the phone shows that
// page's bar in this one's place, never both.
const TABS = [
  { to: '/', label: 'Queue', Icon: Inbox, end: true },
  { to: '/command-center', label: 'CC', Icon: Radio },
  { to: '/traffic', label: 'Traffic', Icon: ListChecks },
  { to: '/search', label: 'Accounts', Icon: Users },
  { to: '/more', label: 'More', Icon: MoreHorizontal },
];

export default function BottomTabBar() {
  const owner = useShellStore((s) => s.bottomBar);
  if (owner !== SHELL_BOTTOM_BAR) return null;
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-bg/95 backdrop-blur md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex h-tab-h">
        {TABS.map(({ to, label, Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                [
                  'flex h-full flex-col items-center justify-center gap-0.5',
                  'min-h-[44px] min-w-[44px]',
                  isActive ? 'text-accent' : 'text-text-dim hover:text-text-muted',
                ].join(' ')
              }
            >
              <Icon size={20} strokeWidth={1.5} />
              <span className="text-[10px] font-medium tracking-wide">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
